import { reverse, sort as sortFunc } from "ramda";
import { ISort } from "../hooks/useTableSort";

export const getSortedList = <T>(sort: ISort, array: T[]): T[]  => {
    if (!sort) {
        return array;
    }
    let sortKey = '';
    for (const key in sort) {
        sortKey = key;
    }
    const sortValue = sort[sortKey];

    const sorted = sortFunc((a, b) => {
        // @ts-ignore
        const valueA = a?.[sortKey] ?? undefined;
        // @ts-ignore
        const valueB = b?.[sortKey] ?? undefined;
        if (!valueA && !valueB) {
            return 0;
        }
        if (typeof valueA === 'number' && typeof valueB === 'number') {
            return valueA - valueB;
        }
        if (typeof valueA !== 'string') {
            return 1;
        }
        if (typeof valueB !== 'string') {
            return -1;
        }
        return valueA.localeCompare(valueB);

    }, array);
    return sortValue === 1 ? sorted : reverse(sorted);
}